import { forwardRef } from 'react'

import BaseTripItemSummaryCard from './BaseTripItemSummaryCard'
import { startPlaceOfTripItem } from '../../utils'

import { usePlaceRating } from 'tripPlanner/hooks/Google/usePlaceRating'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { isCustomItem } from 'tripPlanner/utils'

interface Props {
  className?: string
  item: TripItem
  showCloseButton?: boolean
  onClose?: () => void
}

const CustomItemSummaryCard = forwardRef<HTMLDivElement, Props>(
  ({ className, item, showCloseButton, onClose }, ref) => {
    const place = startPlaceOfTripItem(item)
    const { data: rating } = usePlaceRating(
      place?.id ?? '',
      place?.id !== undefined && isCustomItem(item),
    )

    if (!place) {
      return null
    }

    return (
      <BaseTripItemSummaryCard
        ref={ref}
        className={className}
        item={item}
        showCloseButton={showCloseButton}
        onClose={onClose}
        rating={rating}
        place={place}
      />
    )
  },
)

export default CustomItemSummaryCard
